module.exports = __webpack_public_path__ + "img/ccc.747e26d1.png";